<template>
	<div :class="lookupCls"
	    @mouseenter="hover = true"
	    @mouseleave="hover = false">
	    <!-- 已选项展示 -->
		<div :class="prefixCls + '-content'"
		    @click="onSearch">
		    <template v-if="finalReadonly">
		    	<span :class="prefixCls + '-text-content'">
	                {{ normalizeValueText }}
	            </span>
		    </template>
		    <template v-else>
		    	<div :class="prefixCls + '-item'"
				    v-for="(item, i) in normalizeValue">
					{{item.text}}
					<Icon v-if="isEditable"
					    type="ios-close"
					    :class="prefixCls + '-deselect'"
					    :data-value="item.value"
					    :size="14"
					    @click.native="deSelect">
					</Icon>
				</div>
		    </template>
		</div>
		<!-- 清空 -->
		<Icon v-if="isClearable"
		    type="ios-close-circle"
		    :class="prefixCls + '-clear'"
		    :size="14"
		    @click.native="onClear"></Icon>
	    <!-- 查找 -->
		<Icon v-else
		    type="ios-search"
		    :class="prefixCls + '-lookup'"
		    :size="14"></Icon>
	    <!-- 弹出框 -->
		<smart-modal ref="innerModal"
		    v-bind="$attrs"
		    v-on="$listeners"
		    v-model="showModal"
		    :height="modalHeight"
		    :width="modalWidth"
		    @on-visible-change='onVisibleChange'>
			<slot></slot>
		</smart-modal>
	</div>
</template>
<script>
import Icon from "../icon"
import smartModal from "../smart-modal"
import Field from '../../mixins/field'
import { type } from '../../utils/assist'

export default {
	name: "FormLookup",
	mixins: [Field],
	composed: true,
	components: {
		Icon,
		smartModal
	},
	props: {
		size: {
			type: String,
			default: "default"
		},
		value: {
			type: [Array, String, Number],
			default: ""
		},
		clearable: {
			type: Boolean,
			default: true
		},
		textSymbol: {
			type: String,
			default: "name"
		},
		valueSymbol: {
			type: String,
			default: "id"
		},
		modalHeight: {
			type: Number,
			default: 540
		},
		modalWidth: {
			type: Number,
			default: 800
		},
		title: {
			type: String,
			default: ""
		},
		buttons: {
			type: Array
		},
		options: {
			type: Array,
			default: function() {
				return []
			}
		}
	},

	inheritAttrs: false,

	data() {
		return {
			showModal: false,
			$win: null,
			hover: false,
		}
	},

	model: {
		prop: "value",
		event: "change"
	},

	computed: {
		prefixCls() {
			return "ivu-form-lookup"
		},
		lookupCls() {
			return [
				[this.prefixCls],
				{
					"is-readonly": this.finalReadonly,
					"is-disabled": this.finalDisabled
				}
			]
		},
		isEditable() {
			return !this.finalReadonly && !this.finalDisabled
		},
		isClearable() {
			if (this.hover && this.clearable && this.isEditable) {
				if (this.normalizeValue.length > 0) return true
			}

			return false
		},
		normalizeValue() {
			var value = this.value || "",
				valType = type(value)

			// normalize
			if (valType == "string" || valType == "number") {
				value += ""
				value = value ? value.split(",") : []
			}

			return value.map(v => {
				var _value, _text, option

				if (type(v) == "object") {
					_value = v[this.valueSymbol]
					option = this.mapOptions[_value] || {}
					_text = v[this.textSymbol] || option[this.textSymbol] || _value
				} else {
					_value = v
					option = this.mapOptions[_value] || {}
					_text = option[this.textSymbol] || _value
				}

				return {
					value: _value,
					text: _text || _value
				}
			})
		},
		normalizeValueText(){
			return this.normalizeValue.map(v => v.text).join(",")
		},
		mapOptions() {
			return this.options.reduce((memo, v) => {
				memo[v[this.valueSymbol]] = v

				return memo
			}, {})
		}
	},
	methods: {
		onClear(e) {
			e.stopPropagation()

			this.onChange([])
			this.$emit("clear")
		},
		deSelect(e) {
			var target = e.target

			e.stopPropagation()

			// 点击x号
			if (target.className.indexOf(this.prefixCls + '-deselect') >= 0) {
				// 取消项
				var _value = target.dataset.value,
					_option = this.mapOptions[_value]
				
				// 已选择项
				var selected = this.normalizeValue.map(v => v.value)
				selected.splice(this.normalizeValue.findIndex(v => v.value == _value), 1)
				
				// 已选择项列表
				var	selectedOptions = selected.map(id => this.mapOptions[id])
				this.onChange(selectedOptions)

				// 取消选事件
				this.$emit("deselect", _value, _option)
			}
		},
		onSearch(e) {
			if (this.isEditable) this.showModal = true
		},
		onChange(data) {
			if (type(data) != "array") {
				data = [data]
			}

			// options.sync
			this.$emit("update:options", data)
			var value = data.map(v => v[this.valueSymbol]).join(",")

			// v-model
			this.$emit("change", value, data)
		},
		onVisibleChange(isShow) {
			var $modal = this.$refs.innerModal

			if (isShow) {
				$modal.$emit("lookup-open", this.normalizeValue)
			}

			this.$emit("on-visible-change", isShow)
		}
	},
	mounted() {
		var $modal = this.$refs.innerModal

		$modal.$on("lookup-close", data => {
			this.onChange(data)
			$modal.close()
		})
	},
	watch: {
		value(val){
			// 触发表单校验
			this.dispatchFormBlur(val)
		}
	}
}
</script>